const Textbox = ({ id, name, register, errors, title, optional, ...rest }) => {
  return (
    <>
      {title && (
        <label className="form-label" htmlFor={id}>
          {title}
          {optional && (
            <span className="text-xs ml-2 text-gray-300">Optional</span>
          )}
        </label>
      )}
      <input
        id={id}
        name={name}
        className={`form-control ${errors && errors[name] && "form-invalid"}`}
        {...rest}
        {...register}
      />
      {errors && errors[name] && (
        <div className="pt-2">
          <span className="text-sm text-red-400">{errors[name].message}</span>
        </div>
      )}
    </>
  );
};

export default Textbox;
